import util from '@bmp-vue/core/api/util'
const controller = 'Jpcash'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  PropostaAssinaturaCCB (th, data, callback) {
    th.$api.Multiplo.Post('PropostaAssinaturaCCB', data).then(res => {
      if (th.$api.UI.PostLoadData(res, true)) {
        if (callback) callback()
      };
    });
  },
})
